import { render, staticRenderFns } from "./PrecoPrazo.vue?vue&type=template&id=40fc4b40&scoped=true"
import script from "./PrecoPrazo.vue?vue&type=script&lang=js"
export * from "./PrecoPrazo.vue?vue&type=script&lang=js"
import style0 from "./PrecoPrazo.vue?vue&type=style&index=0&id=40fc4b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fc4b40",
  null
  
)

export default component.exports